// extracted by mini-css-extract-plugin
export default {"button":"_1ZZ-7"};